// Traduções do seletor de colunas das imagens do Painel de Descarga e da Frota
// pesada, coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'imagemColunas.titulo': 'Colunas da imagem',
    'imagemColunas.restaurar': 'Restaurar padrão',
  },
  en: {
    'imagemColunas.titulo': 'Image columns',
    'imagemColunas.restaurar': 'Restore default',
  },
  es: {
    'imagemColunas.titulo': 'Columnas de la imagen',
    'imagemColunas.restaurar': 'Restaurar predeterminado',
  },
}
